import React, { useState, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Skeleton,
  Stack,
} from "@mui/material";

import { useSelector } from "react-redux";

const YourPropertyDetails = ({ data, loading }) => {
  const modalRef = useRef();
  const theme = useSelector((data) => data.themeValue.colors);
  const [showPaymentModal, setShowPaymentModal] = useState(false); 
  const SqFtPrice = Number(data[0]?.SqFtPrice || 0);
  const SizeInSqFt = data[0]?.SizeInSqFt || 0;
  
  return (
    <Box sx={{ px: { xs: 1, md: 2 }, mt: 3, width: "100%", position: "relative" }}>
      

      {loading ? (
        <Stack spacing={2}>
          <Skeleton variant="rounded" height={90} />
          <Skeleton variant="rounded" height={30} width="50%" />
          <Skeleton variant="rounded" height={30} width="70%" />
        </Stack>
      ) : (
        <>
          <Card
            variant="outlined"
            sx={{
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
              borderBottomLeftRadius: 10,
              backgroundColor:theme.background
            }}
          >
            <CardContent>
                <Typography variant="body1" fontWeight={700} sx={{color:theme.text,fontSize:"20px"}}>
                   {data[0]?.PropertyName || " "}
                </Typography>
             
              <Typography variant="body2" sx={{ mt: 1.5, color:theme.text, fontWeight:500}}>
                Facing: <strong>{data[0]?.Facing}</strong>
              </Typography>
              
              <Divider sx={{ my: 2 ,backgroundColor:theme.secondary_text_color}} />
              <Typography variant="body2" sx={{ mt: 1.5,color:theme.text }}>
                SqFt Price: <strong>{`₹${SqFtPrice}`}</strong>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1.5, color:theme.text}}>
                Total Area: <strong>{` ${SizeInSqFt} SqFt`}</strong>
              </Typography>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row", marginBottom: 1, padding: "10px" },
                gap: 2,
                mt: 3,
                // justifyContent: "center",
              }}
            > 
            </Box>
          </Card>


        </>

      )}
      {/* <Box
        sx={{
          // width: "15%",
          height: "50px",
          paddingRight: "10px",
          backgroundColor: theme.background,
          position: "absolute",
          top: 22,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          textAlign: "center",
        }}
      >
        <Button
          size="small"
          sx={{ mt: 1.25 }} // Equivalent to ~10px
          onClick={() => navigate("/market-trend", { state: { data } })}
        >
          See Market Trend
        </Button>
      </Box> */}
      {/* Advanced Payment Modal */}
      {showPaymentModal && (
        <div
          className="modalOverlay"
          style={styles.modalOverlay}
          onClick={(e) => {
            // If clicked outside of modal, close the popup
            if (modalRef.current && !modalRef.current.contains(e.target)) {
              setShowPaymentModal(false);
            }
          }}
        >
          <div ref={modalRef} style={styles.modal}>
            <h3 style={styles.modalTitle}> {data?.PropertyName}</h3> {/* Display Property Name */}

          
          
          </div>
        </div>
      )}

    </Box>
  );
};

// Reusable info row component
const GridInfo = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, fontSize: 14 }}>
    <Typography color="text.secondary">{label}:</Typography>
    <Typography fontWeight={500}>{value}</Typography>
  </Box>
);

export default YourPropertyDetails;


const styles = {

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "400px",
  },
  modalTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },
  copyInputGroup: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  copyInputField: {
    flex: 1,
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  copyIcon: {
    marginLeft: "8px",
    fontSize: "18px",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  shareButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  shareBtn: {
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
   buttonOutline: {
    border: "1px solid #1976d2",
    backgroundColor: "white",
    color: "#1976d2",
    padding: "10px 16px",
    borderRadius: "4px",
    cursor: "pointer",
  },
};
